import React, { useState, useEffect } from "react";
import "../../../assets/css/cms/Products.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import CustomEditor5 from "../../../utils/ckEditor5";
import { getPrivacyPolicy, postPrivacyPolicy, clearPostPrivacyPolicyResponse } from "../../../../store/slices/staticPages"
import { useDispatch, useSelector } from "react-redux";
import Alert from "@mui/material/Alert";
//Datepicker
import DesktopDatePicker from "@mui/lab/DatePicker";
import Box from '@mui/material/Box'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'

function PrivacyPolicy(props) {
    const dispatch = useDispatch();
    const [publishStatus, setPublishStatus] = useState(false)
    const [text, setText] = useState('')
    const [versiondate, setVersionDate] = useState(new Date())

    const { privacyPolicyData, postPrivacyPolicyData, privacyPolicyDataError, postPrivacyPolicyError } = useSelector((state) => {
        return state.staticPagesReducer;
    });

    useEffect(() => {
        dispatch(getPrivacyPolicy({ type: "Privacy_Policy" }))
    }, [])

    useEffect(() => {
        if (privacyPolicyData) {
            setText(privacyPolicyData?.text)
            setPublishStatus(privacyPolicyData?.is_published)
            setVersionDate(privacyPolicyData?.version_date)
        }
    }, [privacyPolicyData])

    useEffect(() => {
        if (
            postPrivacyPolicyData
        ) {
            setTimeout(() => {
                dispatch(clearPostPrivacyPolicyResponse())
            }, 1000);
        }
        if (
            postPrivacyPolicyError
        ) {
            setTimeout(() => {
                dispatch(clearPostPrivacyPolicyResponse())
            }, 2000);
        }
    }, [
        (postPrivacyPolicyData || postPrivacyPolicyError)
    ]);


    const handleSubmit = (e) => {
        e.preventDefault()
        let data = {}
        data.text = text
        data.is_published = publishStatus
        data.type = "Privacy_Policy"
        data.version_date = versiondate
        dispatch(postPrivacyPolicy(data))
    }
    
    return (
        <div>
            <div className={"notification_popup"}>
                {(postPrivacyPolicyData || postPrivacyPolicyError)
                    && (
                        <Alert severity={(postPrivacyPolicyError) ? `error` : `success`}>
                            {" "}
                            {(postPrivacyPolicyError) ? "Failure: Privacy Policy not Updated" : "Privacy Policy Updated Successfully"}{" "}
                        </Alert>
                    )}
            </div>
            <div className={"url_other_details"}>
                <div className={"examfilter"}>
                    <h4>Privacy Policy</h4>
                    <br></br>
                    <Row>
                        <Col sm={12}>
                            <Form.Group className="mb-3" controlId="synopsis">
                            {(text || text==undefined||text=== '' || text===null)&&(
                                <CustomEditor5
                                    name="description"
                                    initData={text}
                                    onChange={(data) => {
                                        setText(data);
                                    }} 
                                />
                            )}
                            </Form.Group>
                        </Col>
                        </Row>
                        <Row className="my-4">
                        <Col md={4} sm={2}>
                        <Form.Group className="mb-3 date_input" controlId="Version date">
                            <Form.Label>This field specifies the draft date of the latest document. Select the draft date here</Form.Label>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DesktopDatePicker
                                    label="This field specifies the draft date of the latest document. Enter the draft date here"
                                    value={versiondate}
                                    onChange={(date) => {
                                    setVersionDate(date.toISOString());
                                    }}
                                    renderInput={({
                                        inputRef,
                                        inputProps,
                                        InputProps,
                                    }) => (
                                        <Box
                                            sx={{ display: "flex", alignItems: "center" }}
                                        >
                                            <Form.Control
                                                ref={inputRef}
                                                {...inputProps}
                                                className={"input_pd"}
                                                disabled
                                            />
                                            {InputProps?.endAdornment}
                                        </Box>
                                    )}
                                />
                            </LocalizationProvider>
                            
                        </Form.Group>
                        </Col>
                        </Row>
                        <Row>
                        <Col md={11} >
                            <div className={""}>
                                <Form.Group className="mb-3">
                                    <div className="d-flex">
                                        <Form.Check
                                            className={"checkbox"}
                                            checked={publishStatus}
                                            onChange={(event) =>
                                                setPublishStatus(
                                                    event.target.checked
                                                )
                                            }
                                        />
                                        <Form.Label> Publish</Form.Label>
                                    </div>
                                </Form.Group>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="mt-4">
                    <button
                        className={"exam_button"}
                        type="submit"
                        onClick={(e) => handleSubmit(e)}
                    >
                        Save
                    </button>
                </div>
            </div>
        </div >
    );
}

export default PrivacyPolicy;
